/**
 * SAML SSO Login Button Component
 * Displays a "Login with SSO" button that initiates the SAML flow
 */

import { Button, CircularProgress } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { initiateSAMLLogin } from '../services/samlService';

export default function SamlLoginButton({ tenantCode, disabled, loading }) {
    const handleClick = () => {
        if (!disabled && !loading && tenantCode) {
            initiateSAMLLogin(tenantCode);
        }
    };

    return (
        <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleClick}
            disabled={disabled || loading || !tenantCode}
            startIcon={loading ? <CircularProgress size={20} /> : <LoginIcon />}
            sx={{
                py: 1.5,
                fontSize: '1rem',
                textTransform: 'none',
            }}
        >
            {loading ? 'Loading...' : 'Sign in with SSO'}
        </Button>
    );
}
